var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 17.0542L17.875 17.0542C18.6344 17.0542 19.25 16.4386 19.25 15.6792V6.0542C19.25 5.29481 18.6344 4.6792 17.875 4.6792L4.125 4.6792C3.36561 4.6792 2.75 5.29481 2.75 6.0542V15.6792C2.75 16.4386 3.36561 17.0542 4.125 17.0542Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.8042H8.25",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 13.6167H19.25",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.0542V19.8042",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarDesktop);
export default __webpack_public_path__ + "static/media/icon-sidebar-desktop.38d1e7d29df43945efa0ca83978803b9.svg";
export { ForwardRef as ReactComponent };